
import Vue from 'vue';
import { mapActions } from "vuex";
import AddButton from './shared/fileUploader/Add.vue'

export default {

  auth: false,
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    showLabel: {
      type: Boolean,
      default: false
    },
    replace: {
      type: Boolean,
      default: false
    },
    fileTypes: {
      type: String,
      default: 'image/*'
    },
    maxFiles: {
      type: Number,
      default: 6
    },
    container: {
      type: Number,
      default: 5
    },
    uploadedfiles: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      filePondId: null,
      addElm: false,
      addBtn: null,
      listElm: null,
      // fake server to simulate loading a 'local' server file and processing a file
      myServer: {
        process: (fieldName, file, metadata, load) => {
          console.log(file)
          console.log(metadata)
          if (!file.name.match(/https\:\/\/properlly\.blob\.core\.windows\.net/g)) {
            // simulates uploading a file
            let formData = new FormData()
            formData.append(`file`, file)
            this.mediaUpload({ formData, containerId: this.container }).then(data => {
              console.log(data)
              this.$emit('uplodedSucess', data.data.imageUrl)
              file.serverId = data.data.imageUrl
              load(data.data.imageUrl)
            })
          } else {
            console.log(file)
            load(file)
          }
        },

      },
      myFiles: [

      ],
    };
  },
  mounted() {
    console.log('mounted', this.uploadedfiles)

  },
  watch: {
    uploadedfiles: {
      handler(newValue, oldValue) {
        setTimeout(() => {


          console.log('watch', newValue)
          if (newValue.length && process.client) {
            console.log(this.uploadedfiles)
            newValue.forEach(element => {
              console.log(element)

              this.createFileObj(element)
            });
          }
        }, 1000);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapActions('media', ['mediaUpload']),
    ...mapActions('config/site', ['setErrorSnackbar']),
    handleFilePondInit() {

      // FilePond instance methods are available on `this.$refs.pond`

      /* eslint-disable */
      console.log("FilePond has initialized");
      if (this.multiple) {

        this.listElm = document.getElementsByClassName('filepond--list')[0]
        this.filePondId =
          document.getElementsByClassName('filepond--browser')[0].id
        const ComponentClass = Vue.extend(AddButton)
        this.addBtn = new ComponentClass({
          vuetify: this.$vuetify.theme,
          propsData: {
            filePondId: this.filePondId,
            text: 'Choose image file',
            height: this.$refs.filePond.imagePreviewHeight,
          },
        })
        this.addBtn.$mount()
      }
    },
    removeFiles() {
      this.$refs.filePond.removeFiles({ revert: true })
    },
    handleError(err, item) {
      this.setErrorSnackbar({
        title: err.main,
        msg: err.sub,
      })
      setTimeout(() => {
        this.$refs.filePond.removeFile(item)
      }, 1000)
    },
    async createFileObj(file) {
      const res = await this.fetchFileData(file)
      if (res.ok) {

        this.myFiles.push(new File([await res.clone().arrayBuffer()], file, { type: res.clone().headers.get("content-type"), filename: file }))
        // this.$refs.filePond.addFile(new File([await res.clone().arrayBuffer()],file,{ type: res.clone().headers.get("content-type"),filename:file })).then((file) => {
        //     console.log(file)
        //     file.setMetadata({serverId:file.source.name})
        // });
      }
    },
    async fetchFileData(source) {
      return await fetch(source)
    },
    browseFolder() {
      this.$refs.filePond.browse()
    },
    getFiles() {
      const result = []
      this.$refs.filePond.getFiles().forEach(el => {
        if (el.serverId) {
          result.push(el.serverId)
        } else {
          result.push(el.source.name)
        }
      })
      return result
    },

    handleReorder(ev) {
      ev.forEach((el, i) => {
        console.log('handleReorder', el)

        let text = `${this.$t('File')}-${i}-${this.$t('As')}-${this.$t('Image')}`

        if (i === 0) {
          text = this.$t('Cover image')
        } else if (el.fileExtension === 'pdf') {
          text = `${this.$t('File')}-${i}-${this.$t('As')}-${this.$t('PDF')}`
        }
        else if (el.fileExtension === 'doc') {
          text = `${this.$t('File')}-${i}-${this.$t('As')}-${this.$t('DOC')}`
        }
        else if (el.fileExtension === 'docx') {
          text = `${this.$t('File')}-${i}-${this.$t('As')}-${this.$t('DOCX')}`
        }
        document
          .getElementById(`filepond--item-${el.id}`)
          .querySelector('.filepond--file-info-main').innerHTML = text
        let elm = document
          .getElementById(`filepond--item-${el.id}`)
          .querySelector('.filepond--file-info')

        if (el.fileExtension === 'pdf' || el.fileExtension === 'doc' || el.fileExtension === 'docx') {
          console.log(elm)
          elm.setAttribute("style", "transform:translate3d(150px, 83px, 0px)!important; font-size:24px!important;");
        }
      })
    },

  },
}   
